import { ILoggedCustomer, IPurchaseCategory } from "api/types";
import gql from "graphql-tag";
import * as React from "react";
import { Query } from "react-apollo";

export const TabletStartupDataContext = React.createContext<
  [IPurchaseCategory] | undefined
>(undefined);

interface IProps {
  children: React.ReactNode;
}

export default ({ children }: IProps) => (
  <Query
    query={gql`
      {
        getPurchaseCategories {
          id
          name
        }
      }
    `}
    fetchPolicy="cache-and-network"
  >
    {props => {
      const { data } = props;
      return (
        <TabletStartupDataContext.Provider
          value={
            (data &&
              data.getPurchaseCategories &&
              data.getPurchaseCategories
                .slice()
                .sort((a: IPurchaseCategory, b: IPurchaseCategory) =>
                  a.name < b.name ? -1 : a.name > b.name ? 1 : 0
                )) ||
            []
          }
        >
          {children}
        </TabletStartupDataContext.Provider>
      );
    }}
  </Query>
);



// WEBPACK FOOTER //
// ./src/components/Gates/TabletStartupGate.tsx